import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {NotificationsToggleClickEvent} from "../models/events/notifications-toggle-click-event";
import {APP} from "../app/consts";

export class ToggleEnableNotificationsHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.toggleEnableNotifications;
  analyticsService: AnalyticsService;
  localStorageUtils: LocalStorageUtils;

  static injectables = [AnalyticsService, LocalStorageUtils];

  constructor(analyticsService: AnalyticsService, localStorageUtils: LocalStorageUtils) {
    super(analyticsService);

    this.eventType = NotificationsToggleClickEvent;
    this.analyticsService = analyticsService;
    this.localStorageUtils = localStorageUtils;
  }
  action(params) {
    this.appStore.state.enableNotifications = params.isActive;

    if (params.isActive) {
      this.controller.action(APP.ACTION_TYPES.pushNotificationsRequestPermissionHandler);
    }
    this.controller.action(APP.ACTION_TYPES.fetchUsers);
    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.enableNotifications, params.isActive);

    super.action(params)
  }
}
